export const NAVIGATION_DIRECTION = {
    FORWARD: 1,
    BACKWARD: -1,
} as const;

export type NavigationDirection = (typeof NAVIGATION_DIRECTION)[keyof typeof NAVIGATION_DIRECTION];
